export default __webpack_public_path__ + "static/media/Winchester, Hugh.04248980.pdf";